import { gql } from '@apollo/client';

export * from './finishOauthIntegrationAuth.mutation.generated';

export const FINISH_OAUTH_INTEGRATION_AUTH = gql`
  mutation finishOauthIntegrationAuth(
    $provider: OauthIntegrationProviderEnum!
    $clientPayload: IntegrationAuthClientPayloadInput!
    $stateToken: String!
    $options: IntegrationAuthOptionsInput
  ) {
    finishOauthIntegrationAuth(
      input: { provider: $provider, clientPayload: $clientPayload, stateToken: $stateToken, options: $options }
    ) {
      success
      errors
      oauthIntegration {
        id
        accountName
        provider
      }
    }
  }
`;
